///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { GtthKeyValueDTO, UserActivityEventDTO } from '../../generated/shared-types.model';
import { AuditsService } from '../audits/service/audits.service';
import { PagedModel } from '../../generated/spring-types.model';
import { UserActivityEventQueryParams } from './user-activity-types';

@Injectable()
export class GtthUserActivityService {
    private readonly fetchUrl = 'api/user-activity';

    constructor(
        private readonly http: HttpClient,
        private readonly auditService: AuditsService
    ) {}

    public getEventTypes(): Observable<GtthKeyValueDTO[]> {
        return this.http.get<GtthKeyValueDTO[]>(`${this.fetchUrl}/event-types`).pipe(catchError(() => of([])));
    }

    public getEvents(req: UserActivityEventQueryParams): Observable<PagedModel<UserActivityEventDTO>> {
        return this.http.get<PagedModel<UserActivityEventDTO>>(`${this.fetchUrl}/events`, {
            params: this.setReqParams(req)
        });
    }

    private setReqParams(req, params?: HttpParams) {
        params = params || new HttpParams();
        const reqForAudit = { ...req };
        if (req?.fromDate) {
            reqForAudit.from = req.fromDate;
        }
        if (req?.toDate) {
            reqForAudit.to = req.toDate;
        }
        if (req?.page) {
            reqForAudit.page = req.page - 1;
        }

        if (req && Object.keys(req).length !== 0) {
            params = this.auditService.preparePaginationParams(reqForAudit, params);

            if (req.companyId) {
                params = params.append('companyId', req.companyId);
            }
            if (req.userId) {
                params = params.append('userId', req.userId);
            }
            if (req.eventIds || req.eventIds === 0) {
                params = params.append('eventIds', req.eventIds);
            }
        }

        return params;
    }
}
